import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostData,
  type UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostError,
  type UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostResponse,
  uploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPost,
} from '../../generated';

export type UploadImageToCollectionMutationVariables =
  UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostData['path'] &
    UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostData['body'];

export type UploadImageToCollectionMutation =
  UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostResponse;

export const useUploadImageToCollectionMutation = <
  TError = UploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<UploadImageToCollectionMutation, TError, UploadImageToCollectionMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<UploadImageToCollectionMutation, TError, UploadImageToCollectionMutationVariables, TContext>({
    mutationKey: ['UploadImageToCollection'],
    mutationFn: async ({ workspace_id, collection_id, ...body }: UploadImageToCollectionMutationVariables) => {
      const { data } =
        await uploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPost({
          path: { workspace_id, collection_id },
          body,
          throwOnError: true,
        });
      return data;
    },
    ...options,
  });
};

useUploadImageToCollectionMutation.fetcher = (
  { workspace_id, collection_id, ...body }: UploadImageToCollectionMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await uploadImageToCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesPost({
      path: { workspace_id, collection_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
